import type { CalendarApi } from "@fullcalendar/core";
import TableChartIcon from "@mui/icons-material/TableChart";
import {
  Button,
  createTheme,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  ThemeProvider,
  type SelectChangeEvent,
} from "@mui/material";
import CustomDatePicker from "../custom-date-picker/DatePicker";

import { type Team } from "@entities";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TeamsSelectDialog } from "../../teams-select";
import "./CustomToolbar.scss";

export const CustomToolbar = ({
  calendarApi,
  handlefilterSelect,
  handleDateChange,
  changeMaxStack,
  isGroup,
  hideFilterSelect,
  selectedTeams,
}: {
  calendarApi: CalendarApi;
  handlefilterSelect: (
    event: SelectChangeEvent<string>,
    selectedTeams?: string[],
  ) => void;
  handleDateChange: (date: Date | null) => void;
  changeMaxStack: (type: string) => void;
  selectedTeams?: string[];
  isGroup?: boolean;
  hideFilterSelect?: boolean;
}) => {
  const [view, setView] = useState<string>("dayGridMonth");
  const handleViewChange = (event: SelectChangeEvent<string>) => {
    changeMaxStack(event.target.value);
    calendarApi.changeView(event.target.value);
    setView(event.target.value);
  };
  const navigate = useNavigate();
  const [teamsAnchor, setTeamsAnchor] = useState<EventTarget | null | boolean>(
    null,
  );

  const sx = {
    width: "15vw",
    borderRadius: "24px",
    padding: "0",
    height: "5vh",
  };

  function chooseFilter(event: SelectChangeEvent<string>) {
    if (event.target.value === "teams")
      setTeamsAnchor(event.target.value === "teams");
    else handlefilterSelect(event);
  }

  const theme = createTheme({
    palette: {
      primary: {
        main: "#00b4d8",
      },
      secondary: {
        main: "#05204CF2",
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div className="custom-toolbar">
        <div className="main-actions">
          <CustomDatePicker view={view} onDateChange={handleDateChange} />
          {!isGroup ? (
            <FormControl className="form-container">
              <InputLabel id="select-label">תצוגה</InputLabel>
              <Select
                labelId="select-label"
                label="תצוגה"
                onChange={handleViewChange}
                sx={sx}
                className="toolbar-select"
                defaultValue="dayGridMonth"
              >
                <MenuItem value="dayGridMonth">חודש</MenuItem>
                <MenuItem value="timeGridWeek">שבוע</MenuItem>
              </Select>
            </FormControl>
          ) : (
            <FormControl className="form-container">
              <InputLabel id="select-label">סוג מידע</InputLabel>
              <Select
                labelId="select-label"
                label="סוג מידע"
                onChange={chooseFilter}
                sx={sx}
                className="toolbar-select"
                defaultValue="preferredTime"
              >
                <MenuItem value="preferredTime">מועד מועדף</MenuItem>
                <MenuItem value="groupMissions">משימות קבוצתיות</MenuItem>
              </Select>
            </FormControl>
          )}
          <Button
            onClick={() =>
              navigate(!isGroup ? "/events" : "/volunteers-groups")
            }
            sx={{
              gap: "0.3vw",
              borderRadius: "1rem",
              height: "unset !important",
            }}
            color="secondary"
            variant="outlined"
          >
            <TableChartIcon /> מעבר לתצוגת טבלה
          </Button>
        </div>
        {!isGroup && !hideFilterSelect && (
          <FormControl className="form-container">
            <InputLabel id="select-label">סנן לפי</InputLabel>
            <Select
              labelId="select-label"
              label="סנן לפי"
              onChange={chooseFilter}
              className="toolbar-select"
              sx={sx}
              defaultValue="all"
            >
              <MenuItem onClick={() => setTeamsAnchor(true)} value="teams">פרויקטים</MenuItem>
              <MenuItem value="all">הכל (כולל היסטוריה)</MenuItem>
              <MenuItem value="futureOpen">פתוחות</MenuItem>
              <MenuItem value="live">פעילות</MenuItem>
              <MenuItem value="history">היסטוריה</MenuItem>
            </Select>
          </FormControl>
        )}
        <TeamsSelectDialog
          onClose={() => {
            setTeamsAnchor(null);
          }}
          onSave={(teams: (string | Team)[]) => {
            handlefilterSelect(
              { target: { value: "teams" } } as SelectChangeEvent<string>,
              teams as string[],
            );
            setTeamsAnchor(null);
          }}
          value={selectedTeams}
          open={!!teamsAnchor}
        />
      </div>
    </ThemeProvider>
  );
};
